import i18n from 'i18next'

export const getWilayasFromTranslation = () => Object.entries(i18n.t('wilayas', { returnObjects: true })).map(([code, name]) => ({ name, code, id: code }))
